import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { TagColorInfo } from '@blaze-runtime/engine-domain';
import { ScrollerComponent } from '@blaze-shared/shared-ui';
import { trackByField } from '@blaze-shared/shared-util';

import { ChatListItemComponent } from '../chat-list-item/chat-list-item.component';
import { ChatConversation, ChatConversationViewModel } from '../chat.models';

@Component({
  selector: 'be-conversations-list',
  templateUrl: './conversations-list.component.html',
  styleUrls: ['./conversations-list.component.scss'],
  imports: [ChatListItemComponent, ScrollerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationsListComponent {
  selectedConversationChange = output<ChatConversation>();

  @Input() allConversationsUnreadMessagesCount: Map<number, number> = new Map();
  @Input() conversations: ChatConversationViewModel[] = [];
  @Input() conversationsColors: Record<string, TagColorInfo> = {};
  @Input() selectedConversationId?: number | null = null;

  readonly trackById = trackByField<ChatConversation>('id');

  selectConversation(conversation: ChatConversation): void {
    this.selectedConversationChange.emit(conversation);
  }
}
